import { milestones } from '@/repositories/devdata';

export default ({
  namespaced: true,
  state: {
    milestones: []
  },
  mutations: {
    initialized(state, { milestones }) {
      state.milestones = milestones;
    }
  },
  actions: {
    initialize({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit('initialized', {
            milestones: milestones
          });
          resolve();
        }
        catch (e) {
          console.error(e);
          reject();
        }
      });
    }
  },
  getters: {
    milestones(state) { return state.milestones; }
  }
});
